/* eslint-disable react/prefer-stateless-function */
import React, { useState } from "react";
import TextInfo, { TEXT_COLOR } from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";
import IconGlyph from "@/bit/components/components.icon-glyph";
import CmsDetailCardList from "@/bit/components/components.cms-block.cms-detail-card-list";

const CollapsedDetailCardList = (props) => {
  if (!props) {
    return null;
  }
  const { cards, cmsHandler, blockName, alias } = props;
  const [open, setopen] = useState(false);

  return (
    <div id={blockName || ""} className="container collapsed-cards">
      <CustomLink
        onClick={() => setopen(!open)}
        title="Ver canales a la carta"
        taggingInfo={{
          componentVariation: "",
          componentContent: "Ver canales a la carta",
          eventType: "click",
        }}
        cyData="CollapsedDetailCardList CustomLink"
        className="channel-link"
      >
        <div className="collapsed-cards-link">
          <TextInfo
            text="Ver canales a la carta"
            fontType="font-regular"
            size="caption01"
            color="blue_a"
            display="block"
            cyData="CollapsedDetailCardList Text"
          />
          <IconGlyph
            className={`${open ? "open cheuron" : "cheuron"}`}
            id="cheuron-up-m"
            height={12}
            color={TEXT_COLOR.BLUE}
          />
        </div>
      </CustomLink>
      {open && (
        <CmsDetailCardList
          {...{
            "cms-ml-detail-card-1": cards,
            "background-color": "#fff",
            visible: true,
            carrusel: false,
          }}
          cmsHandler={cmsHandler}
          blockName={blockName}
          alias={alias}
        />
      )}
      <style jsx>{`.collapsed-cards {
  :global(.container) {
    width: 100% !important;
    padding: 0 !important;
  }
  :global(.cms-detail-card-list) {
    padding-top: 0 !important;
  }
  &-link {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    gap: 0.5rem;
    margin-bottom: 24px;
    :global(.cheuron) {
      transform: rotate(180deg);
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      transition: all 0.3s ease-out;
    }

    :global(.open) {
      transform: rotate(0deg);
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      transition: all 0.3s ease-out;
    }
  }
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 768px) {
  }
}
`}</style>
    </div>
  );
};

export default CollapsedDetailCardList;
